// frontend/src/lib/upload.js
// Example upload helper for sending images to a PHP endpoint (multipart/form-data)

export async function uploadImageToServer(file, { endpointUrl, token, maxSize = 5 * 1024 * 1024 } = {}) {
  if (!file) throw new Error('No file provided');
  if (file.size > maxSize) throw new Error('File too large');

  const form = new FormData();
  form.append('image', file);

  const headers = {};
  // Prefer header-based token (safer than including in form field).
  if (token) headers['X-Upload-Token'] = token;

  const resp = await fetch(endpointUrl, {
    method: 'POST',
    body: form,
    headers,
  });

  if (!resp.ok) {
    const text = await resp.text();
    let json = null;
    try { json = JSON.parse(text); } catch(e) {}
    const msg = json && json.error ? json.error : `Upload failed (${resp.status})`;
    throw new Error(msg);
  }

  const data = await resp.json();
  // helpful debug log (can be removed)
  console.debug('uploadImageToServer response', data);
  if (!data.ok) throw new Error(data.error || 'Upload failed');
  return data; // { ok: true, url, filename }
}
